<template>
  <div class="w-full height-100">
    <div class="seth-set bg-primary">
      <div class="absolute top-0 pt-16 pb-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon
              icon="ArrowLeftIcon"
              class="flex"
              svgClasses="w-6 h-6"
            />
            Go Back
          </p>
          <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
            Campaign Dashboard
          </h2>
        </div>
      </div>
    </div>
    <div class="fixed-top px-6 pt-2 pb-8 bg-white">
      <div class="w-full flex justify-between gap-3">
        <div class="h-full w-1/3">
          <div class="items-center bg-white h-full elshadow border-round p-4">
            <div class="flex gap-4 items-start w-full">
              <img
                src="@/assets/images/wplane.png"
                class="w-20 h-20 rounded-full"
              />

              <div class="w-full">
                <small class="text-primary font-medium"
                  >{{ campaignDetails.campaignName }} Campign</small
                >
                <h3 class="text-dark text-2xl font-semibold mb-0">
                  {{
                    campaignDetails.campaign.title
                      ? campaignDetails.campaign.title
                      : campaignDetails.campaign.name
                  }}
                </h3>
                <div
                  v-if="campaignDetails.campaignName !== 'Push Notification'"
                  class="flex gap-2 mt-1 items-center"
                >
                  <p class="col-4f fsize12 font-semibold">Sender ID:</p>
                  <div>
                    <div v-if="campaignDetails.campaignName == 'SMS'">
                      <p class="col-4f fsize12 font-medium">
                        {{ campaignDetails.campaign.sender.sender }}
                      </p>
                    </div>
                    <div v-if="campaignDetails.campaignName == 'Wnats App'">
                      <p class="col-4f fsize12 font-medium">
                        {{ campaignDetails.campaign.sender.source }}
                      </p>
                    </div>
                    <div v-if="campaignDetails.campaignName == 'Email'">
                      <p class="col-4f fsize12 font-medium">
                        {{ campaignDetails.campaign.sender }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex mt-6 justify-between w-full">
              <div>
                <p class="fsize12 font-semibold mb-0 col-4f">Campign ID:</p>
                <p class="fsize12 mb-0 col-4f">12345</p>
              </div>
              <div>
                <p class="fsize12 font-semibold mb-0 col-4f">Date:</p>
                <p class="fsize12 mb-0 col-4f">
                  {{ campaignDetails.campaign.createdAt.split("T")[0] }}
                </p>
              </div>
              <div>
                <p class="fsize12 font-semibold mb-0 col-4f">Status</p>
                <p class="fsize12 mb-0 col-65">Ongoing</p>
              </div>
            </div>
          </div>
          <div class="mt-2 bg-white p-4 shadow-lg border-round content">
            <el-collapse v-model="activeNames" @change="handleChange" accordion>
              <el-collapse-item name="1">
                <template slot="title">
                  <h1
                    class="font-semibold text-dark mb-0 ml-2 bg-white text-lg"
                  >
                    Content
                  </h1>
                </template>
                <div class="mt-2 grid grid-cols-1 gap-3 p-2">
                  <div v-if="campaignDetails.campaignName == 'Email'">
                    <div class="p-2 bg-white border-round flex items-center">
                      <div class="items-center w-10/12">
                        <h1 class="font-semibold text-dark mb-0 text-lg">
                          Subject:
                        </h1>
                        <p class="col-4f fsize12 font-medium">
                          {{ campaignDetails.campaign.templateid.subject }}
                        </p>
                      </div>
                      <!-- <div class="w-2/12 flex justify-end">
                        <img
                          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/bell.png"
                          class="w-16 h-16 bg-f9 rounded-full p-4"
                        />
                      </div> -->
                    </div>
                    <div class="p-2 bg-white border-round flex items-center">
                      <div class="items-center w-10/12">
                        <h1 class="font-semibold text-dark mb-0 text-lg">
                          Mail Body:
                        </h1>
                        <p
                          v-if="campaignDetails.campaign.templateid.body1"
                          class="col-4f fsize12 font-medium"
                          v-html="campaignDetails.campaign.templateid.body1"
                        ></p>
                        <p
                          v-if="campaignDetails.campaign.templateid.body2"
                          class="col-4f fsize12 font-medium"
                          v-html="campaignDetails.campaign.templateid.body2"
                        ></p>
                      </div>
                      <!-- <div class="w-2/12 flex justify-end">
                        <img
                          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/bell.png"
                          class="w-16 h-16 bg-f9 rounded-full p-4"
                        />
                      </div> -->
                    </div>
                  </div>
                  <div v-if="campaignDetails.campaignName == 'SMS'">
                    <div class="p-2 bg-white border-round flex items-center">
                      <div class="items-center w-10/12">
                        <h1 class="font-semibold text-dark mb-0 text-lg">
                          SMS Body:
                        </h1>
                        <p class="col-4f fsize12 font-medium">
                          {{ campaignDetails.campaign.template.smsBody }}
                        </p>
                      </div>
                      <div class="w-2/12 flex justify-end">
                        <img
                          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/bell.png"
                          class="w-16 h-16 bg-f9 rounded-full p-4"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="campaignDetails.campaignName == 'Whats App'">
                    <div class="p-2 bg-white border-round flex items-center">
                      <div class="items-center w-10/12">
                        <h1 class="font-semibold text-dark mb-0 text-lg">
                          Message Body:
                        </h1>
                        <p
                          v-if="campaignDetails.campaign.variableHeader"
                          class="col-4f fsize12 font-medium"
                        >
                          {{ campaignDetails.campaign.variableHeader }}
                        </p>
                        <br />
                        <p
                          class="col-4f fsize12 font-medium"
                          v-html="
                            htmlData(campaignDetails.campaign.templateText)
                          "
                        ></p>
                        <!-- <p class="col-4f fsize12 font-medium">
                          {{
                            campaignDetails.campaign.templateText.replaceAll(
                              "\r",
                              "\n"
                            )
                          }}
                        </p> -->
                      </div>
                      <!-- <div class="w-2/12 flex justify-end">
                        <img
                          src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/bell.png"
                          class="w-16 h-16 bg-f9 rounded-full p-4"
                        />
                      </div> -->
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <div
          class="h-full w-8/12 bg-white rounded-lg h-full py-4 px-4 shadow-lg"
        >
          <div class="flex">
            <div v-if="campaignDetails.campaignName == 'Email'" class="w-1/2">
              <div class="mb-4">
                <div class="items-center">
                  <h1 class="font-semibold text-dark text-2xl">Performance</h1>
                </div>
              </div>
              <EmailPiChart :campaignData="campaignEmailData()" />
            </div>
            <div v-if="campaignDetails.campaignName == 'SMS'" class="w-1/2">
              <div class="mb-4">
                <div class="items-center">
                  <h1 class="font-semibold text-dark text-2xl">Performance</h1>
                </div>
              </div>
              <SMSPiChart :campaignData="campaignSMSData()" />
            </div>
            <div
              v-if="campaignDetails.campaignName == 'Whats App'"
              class="w-1/2"
            >
              <div class="mb-4">
                <div class="items-center">
                  <h1 class="font-semibold text-dark text-2xl">Performance</h1>
                </div>
              </div>
              <WhatsAppPieChart :campaignData="campaignWhatsAppData()" />
            </div>
            <div class="w-1/2 pl-8">
              <div class="grid grid-cols-2 gap-4 mt-16">
                <div>
                  <p
                    class="col-4f fsize12 flex gap-2 mb-0 items-center font-semibold"
                  >
                    <span class="grayh p-2 font-semibold"></span>TG Size:
                  </p>
                  <p
                    v-if="campaignDetails.campaignName == 'Email'"
                    class="col-b8 text-xl ml-6"
                  >
                    {{ campaignDetails.campaign.userIds.length }}
                  </p>
                  <p
                    v-if="campaignDetails.campaignName == 'Whats App'"
                    class="col-b8 text-xl ml-6"
                  >
                    {{ campaignDetails.campaign.totalSent.length }}
                  </p>
                  <p
                    v-if="campaignDetails.campaignName == 'SMS'"
                    class="col-b8 text-xl ml-6"
                  >
                    {{ campaignDetails.campaign.uniqueUser.length }}
                  </p>
                </div>
                <div>
                  <p
                    class="col-4f fsize12 flex gap-2 mb-0 items-center font-semibold"
                  >
                    <span class="lightpinkh p-2 font-semibold"></span>Delivered:
                  </p>
                  <p class="col-b8 text-xl ml-6">{{ this.progress }}%</p>
                </div>
                <div>
                  <p
                    class="col-4f fsize12 flex gap-2 mb-0 items-center font-semibold"
                  >
                    <span class="pinkh p-2 font-semibold"></span>Bounced rate:
                  </p>
                  <p class="col-b8 text-xl ml-6">
                    {{
                      campaignDetails.campaign.totalBounced.length
                        ? campaignDetails.campaign.totalBounced.length
                        : "- - - -"
                    }}
                  </p>
                </div>
                <!-- <div>
                <p
                  class="col-4f fsize12 flex gap-2 mb-0 items-center font-semibold"
                >
                  <span class="pinkh p-2 font-semibold"></span>Open rate:
                </p>
                <p class="col-b8 text-xl ml-6">- - - -</p>
              </div> -->
              </div>
              <div
                v-if="campaignDetails.campaignName == 'Email'"
                class="flex gap-2 items-center my-4"
              >
                <p class="col-4f fsize15 font-medium">Overall Performance:</p>
                <p v-if="Outstanding()" class="col-65 fsize15 font-medium">
                  Outstanding ({{ this.progress }})
                </p>
                <p v-if="Excellent()" class="col-65 fsize15 font-medium">
                  Excellent ({{ this.progress }})
                </p>
                <p v-if="Good()" class="col-65 fsize15 font-medium">
                  Good ({{ this.progress }})
                </p>
                <p v-if="Poor()" class="col-65 fsize15 font-medium">
                  Poor ({{ this.progress }})
                </p>
              </div>
            </div>
          </div>
          <EmailUserDetails
            v-if="campaignDetails.campaignName == 'SMS' || 'Email'"
            :userData="campaignDetails"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import EmailPiChart from "./EmailPiChart.vue";
import SMSPiChart from "./SmsPiChart.vue";
import WhatsAppPieChart from "./WhatsAppPieChart.vue";
import EmailUserDetails from "./EmailUserDetails.vue";
export default {
  data() {
    return {
      campaignDetails: {},
      activeNames: ["1"],
      // progress: (4 * 100) / 4,
      progress: "",

      // data: [
      //   { progress: (60 * 100) / 100, color: "red" },
      //   { progress: "40", color: "blue" },
      // ],
    };
  },
  methods: {
    Outstanding() {
      if (this.progress >= 91) {
        return true;
      } else {
        return false;
      }
    },
    Excellent() {
      if (this.progress >= 71 && this.progress <= 90) {
        console.log(true);
        return true;
      } else {
        console.log(false);
        return false;
      }
    },
    Good() {
      if (this.progress >= 51 && this.progress <= 70) {
        return true;
      } else {
        return false;
      }
    },
    Poor() {
      if (this.progress <= 50) {
        return true;
      } else {
        return false;
      }
    },
    progressData() {
      if (this.campaignDetails.campaignName == "SMS") {
        let percentage =
          (this.campaignDetails.campaign.totalDelivered.length * 100) /
          this.campaignDetails.campaign.uniqueUser.length;

        this.progress = percentage.toFixed(2);
        // console.log(this.campaignDetails);
      }
      if (this.campaignDetails.campaignName == "Whats App") {
        // console.log(this.campaignDetails);
        let percentage =
          (this.campaignDetails.campaign.totalDelivered.length * 100) /
          this.campaignDetails.campaign.totalSent.length;

        this.progress = percentage;
      }
      if (this.campaignDetails.campaignName == "Email") {
        // console.log(this.campaignDetails);
        let percentage =
          (this.campaignDetails.campaign.totalDelivered.length * 100) /
          this.campaignDetails.campaign.userIds.length;
        // console.log(percentage);
        this.progress = percentage.toFixed(2);
      }
    },

    htmlData(data) {
      return data.replaceAll("\r", "\n");
    },
    campaignEmailData() {
      let data = [];
      data.push(
        this.campaignDetails.campaign.totalDelivered &&
          this.campaignDetails.campaign.totalDelivered.length
          ? this.campaignDetails.campaign.totalDelivered.length
          : 0
      );
      data.push(0); // for open rate
      data.push(
        this.campaignDetails.campaign.totalBounced &&
          this.campaignDetails.campaign.totalBounced.length
          ? this.campaignDetails.campaign.totalBounced.length
          : 0
      );
      return data;
    },
    campaignSMSData() {
      let data = [];
      data.push(
        this.campaignDetails.campaign.totalDelivered &&
          this.campaignDetails.campaign.totalDelivered.length
          ? this.campaignDetails.campaign.totalDelivered.length
          : 0
      );
      data.push(
        this.campaignDetails.campaign.totalBounced &&
          this.campaignDetails.campaign.totalBounced.length
          ? this.campaignDetails.campaign.totalBounced.length
          : 0
      );
      return data;
    },
    campaignWhatsAppData() {
      let data = [];
      data.push(
        this.campaignDetails.campaign.totalDelivered &&
          this.campaignDetails.campaign.totalDelivered.length
          ? this.campaignDetails.campaign.totalDelivered.length
          : 0
      );
      data.push(
        this.campaignDetails.campaign.totalBounced &&
          this.campaignDetails.campaign.totalBounced.length
          ? this.campaignDetails.campaign.totalBounced.length
          : 0
      );
      return data;
    },
  },
  computed: {
    ...mapState("campaign", { campaign: "campaign" }),
  },
  mounted() {
    this.campaignDetails = this.campaign;
    this.progressData();
    // console.log(this.campaignDetails);
  },
  components: {
    EmailPiChart,
    SMSPiChart,
    EmailUserDetails,
    WhatsAppPieChart,
  },
};
</script>

<style lang="scss">
.content {
  .el-collapse-item__header {
    border-bottom: 1px solid #ebeef5 !important;
  }
  .el-collapse-item__wrap {
    border: none !important;
  }
}
</style>
